export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.enterprise-knowledge-graph': 'Enterprise Knowledge Graph Center',
  'menu.enterprise-knowledge-graph.dashboard': 'Dashboard',
  'menu.enterprise-knowledge-graph.entities': 'My Entities',
  'menu.enterprise-knowledge-graph.entities.list': 'All Entities',
  'menu.enterprise-knowledge-graph.entities.companies': 'Companies',
  'menu.enterprise-knowledge-graph.entities.persons': 'Persons',
  'menu.enterprise-knowledge-graph.entities.products': 'Products',
  'menu.enterprise-knowledge-graph.entities.documents': 'Documents',
  'menu.enterprise-knowledge-graph.platform': 'Platform Knowledge',
  'menu.enterprise-knowledge-graph.platform.search': 'Platform Search',
  'menu.enterprise-knowledge-graph.platform.referenced': 'Referenced Entities',
  'menu.enterprise-knowledge-graph.platform.extensions': 'Entity Extensions',
  'menu.enterprise-knowledge-graph.relations': 'Relations',
  'menu.enterprise-knowledge-graph.business-links': 'Business Links',
  'menu.enterprise-knowledge-graph.graph': 'Graph',
  'menu.enterprise-knowledge-graph.import': 'Import',
  'menu.enterprise-knowledge-graph.import.data-sources': 'Data Sources',
  'menu.enterprise-knowledge-graph.import.tasks': 'Import Tasks',
  'menu.enterprise-knowledge-graph.improvement': 'Improvement',
  'menu.enterprise-knowledge-graph.improvement.incomplete-entities':
    'Incomplete Entities',
  'menu.enterprise-knowledge-graph.improvement.duplicates': 'Duplicates',
  'menu.enterprise-knowledge-graph.ai-assistant': 'AI Assistant',
  'menu.enterprise-knowledge-graph.settings': 'Settings',
};
